import React from 'react';
import { ArrowUpRight, Droplets, Hammer, PenTool, RefreshCw, Waves } from 'lucide-react';
const services = [{
  icon: Droplets,
  number: '01',
  title: 'Natural pools',
  copy: 'A more elemental swim experience, designed around natural filtration and chlorine-free water.'
}, {
  icon: PenTool,
  number: '02',
  title: 'Pool design & new builds',
  copy: 'From the first conversation to a backyard with a sense of place.'
}, {
  icon: RefreshCw,
  number: '03',
  title: 'Conversions & remodels',
  copy: 'Reimagine the water, finish, flow, and feeling of an existing pool.'
}, {
  icon: Waves,
  number: '04',
  title: 'San Juan fiberglass pools',
  copy: 'A streamlined path to an enduring pool with refined, ready-made forms.'
}];
export function Services() {
  return <section id="services" className="bg-[#f4f0e7] py-20 sm:py-28" data-id="element-119">
      <div className="mx-auto max-w-7xl px-5 sm:px-8" data-id="element-120">
        <div className="grid gap-7 md:grid-cols-[0.8fr_1.2fr] md:items-end" data-id="element-121">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#356d70]" data-id="element-122">
            What we make
          </p>
          <div data-id="element-123">
            <h2 className="max-w-2xl text-4xl font-medium tracking-[-0.045em] text-[#173d36] sm:text-5xl" data-id="element-124">
              Every kind of water, with a more considered point of view.
            </h2>
            <p className="mt-5 max-w-xl leading-7 text-[#5d675f]" data-id="element-125">
              Whether you are starting fresh or reworking what is already there,
              we help find the right expression for your home and how you live
              in it.
            </p>
          </div>
        </div>
        <div className="mt-14 grid border-t border-[#c9c3b4] sm:grid-cols-2 lg:grid-cols-4" data-id="element-126">
          {services.map(({
          icon: Icon,
          number,
          title,
          copy
        }) => <article key={title} className="group border-b border-[#c9c3b4] py-7 sm:border-r sm:px-6 sm:last:border-r-0 lg:min-h-[290px] lg:py-8" data-id="element-127">
              <div className="flex items-start justify-between" data-id="element-128">
                <Icon size={25} strokeWidth={1.5} className="text-[#356d70]" aria-hidden="true" data-id="element-129" />
                <span className="font-mono text-xs text-[#758078]" data-id="element-130">
                  {number}
                </span>
              </div>
              <h3 className="mt-16 text-xl font-medium tracking-tight text-[#173d36]" data-id="element-131">
                {title}
              </h3>
              <p className="mt-3 text-sm leading-6 text-[#5d675f]" data-id="element-132">{copy}</p>
              <a href="#consultation" className="mt-5 inline-flex items-center gap-1 text-sm font-medium text-[#173d36] opacity-0 transition group-hover:opacity-100 focus:opacity-100" data-id="element-133">
                Explore <ArrowUpRight size={15} aria-hidden="true" data-id="element-134" />
              </a>
            </article>)}
        </div>
      </div>
    </section>;
}